import { IoClose } from "react-icons/io5";
import { resolveMediaUrl } from "../../../../utility/media";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../../utility/formatCurrency";

const ApprovalViewPlanEstimateDetailsModal = ({ isOpen, onClose, estimate, title }) => {
    const { t } = useTranslation();

    if (!isOpen || !estimate) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                {/* Consistent Header Style */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {title} {t('common.details')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body p-6" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    {/* Plan Estimate Information Section */}
                    <div className="flex flex-col gap-3 mb-8 px-4">
                        <DetailRow label={t('forms.planEstimate.workName')} value={estimate.nameOfWork} />
                        <DetailRow label={t('forms.planEstimate.location')} value={estimate.districtName} />
                        <DetailRow label={t('forms.planEstimate.workType')} value={estimate.workTypeName} />
                        <DetailRow label={t('forms.planEstimate.estimateCost')} value={formatCurrency(estimate.estimateCost)} />
                        <DetailRow label={t('forms.planEstimate.date')} value={estimate.date} />
                    </div>

                    {/* Attachments Table - Grouped view matching image_b9975b.png */}
                    <div className="border border-black rounded-sm overflow-hidden mx-auto mb-4">
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-black">
                                    <th className="p-2 text-center border-r border-black font-bold w-16">{t('tables.srNo')}</th>
                                    <th className="p-2 border-r border-black font-bold text-center">{t('common.description')}</th>
                                    <th className="p-2 text-center font-bold">{t('common.attachments')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {estimate.attachmentData && estimate.attachmentData.length > 0 ? (
                                    estimate.attachmentData.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-black last:border-0">
                                            <td className="p-2 text-center border-r border-black">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-black">
                                                {item.description}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.attachmentUrl ? (
                                                    <a 
                                                        href={resolveMediaUrl(item.attachmentUrl)} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline hover:text-blue-800"
                                                    >
                                                        {item.attachmentName || t('tables.view')}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">{t('common.noFile')}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">
                                            {t('common.noAttachment')}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Standard Footer */}
                <div className="staff-form-footer border-t p-4 flex justify-center bg-gray-50">
                    <button className="staff-btn-save px-12" onClick={onClose}>
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

/**
 * Helper component for consistent "Label : Value" alignment
 * following the design shown in the Plan Estimate Details screenshot.
 */
const DetailRow = ({ label, value }) => (
    <div className="grid grid-cols-12 gap-2 text-sm">
        <span className="col-span-4 text-right text-gray-700 font-medium">{label}</span>
        <span className="col-span-1 text-center font-bold text-gray-800">:</span>
        <span className="col-span-7 text-left font-bold text-gray-800">
            {value || "—"}
        </span>
    </div>
);

export default ApprovalViewPlanEstimateDetailsModal;